(() => {
  if (customElements.get('bs-delivery-info')) return;
  let dialogCount = 0;

  customElements.define('bs-delivery-info', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      this.trigger = this.querySelector('.bs-delivery-info-trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.dialog.id = `bs-delivery-info-${++dialogCount}`;
      this.trigger.setAttribute('aria-controls', this.dialog.id);
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('bs-delivery-info-open');
        this.dialog.querySelector('[data-delivery-info-close]').focus({ preventScroll: true });
      }, { signal });
      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-delivery-info-close]')) {
          this.dialog.close();
          return;
        }
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
          this.dialog.close();
        }
      }, { signal });
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.releaseScroll();
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      }, { signal });
    }

    releaseScroll() {
      if (!document.querySelector('.bs-delivery-info-dialog[open]')) {
        document.documentElement.classList.remove('bs-delivery-info-open');
      }
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
      this.releaseScroll();
    }
  });
})();

